(function () {
  'use strict';
  const weightPrice = lb => lb * 250; // Original CAD price per pair: $2.50 per lb of the labelled weight.
  function rangeSummary(start, end) {
    if (!Number.isInteger(start) || !Number.isInteger(end) || start < 5 || end > 110 || start % 5 || end % 5 || end < start) return null;
    const weights = [];
    for (let weight = start; weight <= end; weight += 5) weights.push(weight);
    return {weights, pairs:weights.length, mass:weights.reduce((sum,w)=>sum+w*2,0), price:weights.reduce((sum,w)=>sum+weightPrice(w),0)};
  }
  function initialize(root) {
    root.querySelectorAll('[data-xr-weight-builder]').forEach(builder => {
      if (builder.dataset.initialized) return;
      const section = builder.closest('.product-section');
      const form = document.getElementById(builder.dataset.formId);
      if (!section || !form) return;
      builder.dataset.initialized = 'true';
      const start = builder.querySelector('[data-xr-weight-start]');
      const end = builder.querySelector('[data-xr-weight-end]');
      const nativeOption = builder.querySelector('[data-xr-weight-variant]');
      const variants = JSON.parse(builder.querySelector('[data-xr-weight-variants]').textContent);
      const panel = section.querySelector('[data-xr-dumbbell-racks]');
      const button = form.querySelector('[data-add-to-cart]');
      const master = form.querySelector('[name=id]');
      const moneyFormat = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style:'currency',currency:builder.dataset.currency || 'CAD',currencyDisplay:'narrowSymbol'});
      const money = cents => moneyFormat.format(cents / 100);
      const initial = variants.find(v => String(v.id) === String(master.value));
      const match = initial && /^(\d+) - (\d+) LBS without rack$/.exec(initial.title);
      if (match && initial.price >= 50000) { start.value = match[1]; end.value = match[2]; }
      const property = document.createElement('input');
      property.type='hidden'; property.name='properties[Set contents]'; form.appendChild(property);
      let valid = false;
      let selection = null;
      function update() {
        const summary = rangeSummary(Number(start.value), Number(end.value));
        const title = start.value + ' - ' + end.value + ' LBS without rack';
        selection = variants.find(v => v.title === title && v.price >= 50000);
        valid = !!(summary && summary.price >= 50000 && selection && selection.available);
        nativeOption.value = selection ? selection.option1 : '';
        nativeOption.dispatchEvent(new Event('change',{bubbles:true}));
        if (valid) master.value = String(selection.id);
        else master.value = '';
        button.disabled = !valid;
        const message = builder.querySelector('[data-xr-weight-message]');
        builder.querySelector('[data-xr-weight-summary]').textContent = summary ? start.value + '–' + end.value + ' lb · ' + summary.pairs + ' pairs · ' + summary.pairs*2 + ' dumbbells' : 'Choose a valid weight range';
        builder.querySelector('[data-xr-weight-list]').textContent = summary ? summary.weights.join(', ') + ' lb — one pair each' : '';
        builder.querySelector('[data-xr-weight-mass]').textContent = summary ? summary.mass + ' lb total dumbbell weight' : '';
        const price = valid ? selection.price : summary ? summary.price : 0;
        const displayedPrice = section.querySelector('[data-product-price]');
        if (displayedPrice) displayedPrice.textContent = money(price);
        const buttonText = button.querySelector('[data-add-to-cart-text]');
        if (buttonText) buttonText.textContent = valid ? 'Add set to cart' : 'Choose more weights';
        const terms = form.querySelector('.shopify-payment-terms');
        if (terms) terms.hidden = !valid;
        builder.querySelector('[data-xr-start-label]').textContent = start.value + ' lb';
        builder.querySelector('[data-xr-end-label]').textContent = end.value + ' lb';
        start.setAttribute('aria-valuetext',start.value + ' pounds'); end.setAttribute('aria-valuetext',end.value + ' pounds');
        const rail = builder.querySelector('[data-xr-weight-rail]');
        rail.style.setProperty('--range-start',((Number(start.value)-5)/105*100)+'%');
        rail.style.setProperty('--range-end',((Number(end.value)-5)/105*100)+'%');
        rail.querySelectorAll('[data-weight]').forEach(tick=>tick.classList.toggle('is-selected',Number(tick.dataset.weight)>=Number(start.value) && Number(tick.dataset.weight)<=Number(end.value)));
        builder.querySelector('[data-xr-weight-completion]').style.width = Math.min(100,price/50000*100)+'%';
        message.textContent = !summary ? 'Move the handles to choose your training range.' : summary.price < 50000 ? 'Add a few more pairs to complete your training set.' : !valid ? 'This range is currently unavailable. Choose another range.' : 'Your training set is ready. Add an optional rack below.';
        message.classList.remove('is-invalid');
        builder.querySelector('[data-xr-weight-price]').textContent = money(price);
        property.value = summary ? start.value + '–' + end.value + ' lb; one pair per 5 lb increment; ' + summary.pairs + ' pairs (' + summary.pairs*2 + ' dumbbells)' : '';
        if (panel) {
          panel.querySelectorAll('[data-xr-rack-unavailable]').forEach(input=>{input.disabled=true;input.checked=false;});
          const rack = Array.from(panel.querySelectorAll('[data-xr-addon]')).find(row=>row.querySelector('[data-xr-addon-check]').checked);
          const rackPrice = rack ? Number(rack.querySelector('[data-xr-addon-variant]').dataset.price) : 0;
          panel.querySelector('[data-xr-configured-total]').textContent = money(price + rackPrice);
          const warning = panel.querySelector('[data-xr-rack-capacity]');
          const capacity = rack && Number(rack.dataset.capacity);
          warning.hidden = !rack;
          warning.textContent = !rack ? '' : summary && summary.pairs > capacity ? 'Your set has ' + summary.pairs + ' pairs. This rack holds up to ' + capacity + ' pairs; your full set will not fit on one rack.' : 'Nominal capacity: ' + capacity + ' pairs.';
          if (rack && capacity >= 12) warning.textContent += ' Large dumbbells may reduce the number of pairs that fit.';
        }
        section.dispatchEvent(new CustomEvent('xr:configurationChange'));
      }
      start.addEventListener('input',()=>{ if(Number(start.value)>Number(end.value)) end.value=start.value; update(); });
      end.addEventListener('input',()=>{ if(Number(end.value)<Number(start.value)) start.value=end.value; update(); });
      start.addEventListener('change',update); end.addEventListener('change',update);
      if (panel) panel.addEventListener('change',update);
      form.addEventListener('submit',event=>{
        if (!valid || !selection || selection.price < 50000 || master.value !== String(selection.id)) {
          event.preventDefault(); event.stopImmediatePropagation(); update();
          builder.querySelector('[data-xr-weight-message]').scrollIntoView({block:'nearest',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        }
      },true);
      update();
      window.addEventListener('load',update,{once:true});
    });
  }
  window.xrDumbbellSets = {rangeSummary};
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('quickview:loaded',()=>initialize(document));
})();
